import React, { FunctionComponent } from 'react';
import { SEOHeaderTags } from 'components/SEO/SEOHeaderTags';
import { RecordingModel } from 'features/recordings/RecordingModel';

interface RecordingHeaderTagsProps {
  recording: RecordingModel | null;
}

export const RecordingHeaderTags: FunctionComponent<
  RecordingHeaderTagsProps
> = ({ recording }) => {
  if (!recording) {
    return null;
  }

  return (
    <SEOHeaderTags
      title={recording.title}
      description={recording.description}
      image={recording.artworkUrl()}
      url={window.location.href}
    />
  );
};
